import React, { useEffect, useState } from "react";
import ScrollToBottom from "react-scroll-to-bottom";
import '../styles/chat2.css'

function Chat({ socket, username, room }) {
  const [currentMessage, setCurrentMessage] = useState("");
  const [messageList, setMessageList] = useState([]);

  const sendMessage = async () => {
    if (currentMessage !== "") {
      const messageData = {
        room: room,
        author: username,
        message: currentMessage,
        time:
          new Date(Date.now()).getHours() +
          ":" +
          new Date(Date.now()).getMinutes(),
      };

      await socket.emit("send_message", messageData);
      setMessageList((list) => [...list, messageData]);
      console.log(messageData)
      setCurrentMessage("");
    }
  };

  useEffect(() => {
    socket.on("receive_message", (data) => {
      setMessageList((list) => [...list, data]);
      console.log(data)
    });
  }, [socket]);

  return (
    <div className="chat-window">
      <div className="chat-header">
        <p >Department: {room}    </p>
        <p >User : {username}</p>
        
       
      </div>
      <div className="chat-body">
     
        <ScrollToBottom className="message-container">
          {messageList.map((messageContent) => {
            return (
              <div
              className="message"
              id={messageContent.author === username ? "other" : "you"}
            >
                <div>
                  <div className="message-content">
                    <p>{messageContent.message}</p>
                  </div>
                  <div className="message-meta">
                    <p id="time">{messageContent.time}</p>
                
                  </div>
                </div>
              </div>
            );
          })}
        </ScrollToBottom>
      </div>
      <div className="chat-footer">
        <input
          type="text"
          value={currentMessage}
          placeholder="Type your message here"
          onChange={(event) => {
            setCurrentMessage(event.target.value);
          }}
          onKeyPress={(event) => {
            event.key === "Enter" && sendMessage();
          }}
        />
       
      </div>
    </div>
  );
}

export default Chat;